
import { Component, Prop } from "vue-property-decorator";
import { TypedVue } from "@/store/types";

@Component
export default class DiscussionFlag extends TypedVue {
  @Prop({ default: "" }) tooltip!: string;
  @Prop({ default: 12 }) size!: number;

  public visible = false;
  public placeBelow = false;
  public tipStyle: Record<string, string> = {};

  showTip(): void {
    if (!this.tooltip) return;
    this.visible = true;
    // Wait for the tooltip to render so we can measure it before positioning.
    this.$nextTick(() => this.positionTip());
  }

  hideTip(): void {
    this.visible = false;
  }

  // The tooltip uses fixed positioning so it escapes the report's scroll/overflow
  // containers, which would otherwise clip it. That means we have to place it
  // against the viewport manually on each hover/focus.
  positionTip(): void {
    const tip = this.$refs.tip as HTMLElement | undefined;
    const el = this.$el as HTMLElement;
    if (!tip || !el) return;

    const margin = 8;
    const gap = 6;
    const flag = el.getBoundingClientRect();
    const { width: tw, height: th } = tip.getBoundingClientRect();

    // Center over the flag, clamped to stay within the viewport.
    const flagCenter = flag.left + flag.width / 2;
    let left = flagCenter - tw / 2;
    left = Math.max(margin, Math.min(left, window.innerWidth - tw - margin));

    // Prefer above; flip below when there is not enough room at the top.
    this.placeBelow = flag.top - th - gap < margin;
    const top = this.placeBelow ? flag.bottom + gap : flag.top - th - gap;

    this.tipStyle = {
      left: `${Math.round(left)}px`,
      top: `${Math.round(top)}px`,
      "--arrow-left": `${Math.round(flagCenter - left)}px`,
    };
  }
}
